var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRiskMetricActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 20,
    viewBox: "0 0 14 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bulk/timer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "timer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    opacity: 0.4,
    d: "M13.35 17.68C12.8 19.09 11.46 20 9.94998 20H4.04998C2.52998 20 1.19998 19.09 0.64998 17.68C0.0999801 16.26 0.47998 14.69 1.59998 13.67L5.64998 10H8.35998L12.4 13.67C13.52 14.69 13.89 16.26 13.35 17.68Z",
    fill: "#1DD899"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8.82 16.14H5.18C4.8 16.14 4.5 15.83 4.5 15.46C4.5 15.08 4.81 14.78 5.18 14.78H8.82C9.2 14.78 9.5 15.09 9.5 15.46C9.5 15.83 9.19 16.14 8.82 16.14Z",
    fill: "#1DD899"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M13.3499 2.32C12.7999 0.91 11.4599 0 9.94992 0H4.04992C2.53992 0 1.19992 0.91 0.649916 2.32C0.109916 3.74 0.479916 5.31 1.60992 6.33L5.64992 10H8.35992L12.3999 6.33C13.5199 5.31 13.8899 3.74 13.3499 2.32ZM8.81992 5.23H5.17992C4.79992 5.23 4.49992 4.92 4.49992 4.55C4.49992 4.18 4.80992 3.87 5.17992 3.87H8.81992C9.19992 3.87 9.49992 4.18 9.49992 4.55C9.49992 4.92 9.18992 5.23 8.81992 5.23Z",
    fill: "#1DD899"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRiskMetricActive);
export default __webpack_public_path__ + "static/media/riskMetricActive.b1e9a9032c20e092f240255e0b727e0d.svg";
export { ForwardRef as ReactComponent };